// extracted by mini-css-extract-plugin
export var better__blocks = "style-module--better__blocks--3342f";
export var better__wrap = "style-module--better__wrap--29901";
export var btnBlock = "style-module--btn-block--a8195";
export var counts = "style-module--counts--95159";
export var counts__share = "style-module--counts__share--61d7f";
export var counts__text = "style-module--counts__text--afb99";
export var counts__title = "style-module--counts__title--9ae1a";
export var explanation = "style-module--explanation--19b51";
export var explanation__highlight = "style-module--explanation__highlight--f282a";
export var explanation__title = "style-module--explanation__title--30aba";
export var level__wrap = "style-module--level__wrap--9b15e";
export var wrapper = "style-module--wrapper--ed7ef";